import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'button', 'expandIcon', 'collapseIcon'];
  static values = { expanded: { type: Boolean, default: true } };

  connect() {
    this.applyState();
  }

  toggle() {
    this.expandedValue = !this.expandedValue;
    this.applyState();
  }

  applyState() {
    const expanded = this.expandedValue;

    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle('hidden', !expanded);
    }

    if (this.hasExpandIconTarget) {
      this.expandIconTarget.classList.toggle('hidden', expanded);
    }

    if (this.hasCollapseIconTarget) {
      this.collapseIconTarget.classList.toggle('hidden', !expanded);
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', String(expanded));
      this.buttonTarget.setAttribute('title', expanded ? 'Hide Panel' : 'Show Panel');
      this.buttonTarget.setAttribute('aria-label', expanded ? 'Hide Panel' : 'Show Panel');
    }
  }
}
